var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "path891",
    x: -22,
    y: -18,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#path891)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path891-2",
    "data-name": "path891",
    d: "M28-682.665H0v28H28Z",
    transform: "translate(0 682.66)"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43314",
    "data-name": "Group 43314",
    transform: "translate(-268 8342)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16071",
    "data-name": "Rectangle 16071",
    width: 32,
    height: 32,
    transform: "translate(268 -8342)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "messenger",
    transform: "translate(270 -8340)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g885",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g887"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g889",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g895",
    transform: "translate(1.094 1.094)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path897",
    d: "M-301.76,0a12.906,12.906,0,0,1,12.906,12.906,12.845,12.845,0,0,1-1.956,6.832l1.956,6.074-6.074-1.956a12.845,12.845,0,0,1-6.833,1.956,12.906,12.906,0,0,1-12.906-12.906A12.906,12.906,0,0,1-301.76,0Z",
    transform: "translate(314.666)",
    fill: "none",
    stroke: "#1564e8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g899",
    transform: "translate(12.633 12.633)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path901",
    d: "M-66.667-31.966A1.367,1.367,0,0,0-65.3-30.6a1.367,1.367,0,0,0,1.367-1.367A1.367,1.367,0,0,0-65.3-33.333a1.367,1.367,0,0,0-1.367,1.367",
    transform: "translate(66.667 33.333)",
    fill: "#d1131d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g903",
    transform: "translate(7.164 12.633)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path905",
    d: "M-66.667-31.966A1.367,1.367,0,0,0-65.3-30.6a1.367,1.367,0,0,0,1.367-1.367A1.367,1.367,0,0,0-65.3-33.333a1.367,1.367,0,0,0-1.367,1.367",
    transform: "translate(66.667 33.333)",
    fill: "#d1131d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g907",
    transform: "translate(18.102 12.633)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path909",
    d: "M-66.667-31.966A1.367,1.367,0,0,0-65.3-30.6a1.367,1.367,0,0,0,1.367-1.367A1.367,1.367,0,0,0-65.3-33.333a1.367,1.367,0,0,0-1.367,1.367",
    transform: "translate(66.667 33.333)",
    fill: "#d1131d"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestContent);
export default __webpack_public_path__ + "static/media/request-content.868075b1323f7830219b66faaf7f4d94.svg";
export { ForwardRef as ReactComponent };